module.exports = __webpack_public_path__ + "media/images/icons/eiffla-2dcded63628330e6f2f2173fd287488f.svg";